<template>
    <div class="w100">
        <article class="wContent center" style="padding: 10px 0 20px 0">
            <el-row :gutter="20">
                <el-col :span="16">
                    <div class="p20 bgWhite cus-box">
                        <h4 class="font14">选择定制的品种</h4>
                        <div style="height: 600px; overflow-y: auto; overflow-x: hidden">
                            <el-row>
                                <el-col :span="5">&nbsp;</el-col>
                                <el-col :span="18">
                                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAll" style="margin-bottom: 10px; margin-left: 15px">全选</el-checkbox>
                                </el-col>
                            </el-row>
                            <div v-for="(item, index) in list_data" :key="index">
                                <el-row :gutter="15">
                                    <el-col :span="5">
                                        <div class="textRight font14">
                                            {{ item.productName }} :
                                        </div>
                                    </el-col>
                                    <el-col :span="18">
                                        <div class="check-box radius">
                                            <el-checkbox-group v-model="personalCheckOptions" @change="handleCheckSingle">
                                                <el-checkbox 
                                                v-for="(cItem, cIndex) in item.childList" 
                                                :key="cIndex" 
                                                :label="cItem.productId" 
                                                style="margin-bottom: 10px"
                                                >
                                                {{ cItem.productName }}
                                                </el-checkbox>
                                            </el-checkbox-group>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                        <div class="textCenter">
                            <el-button type="danger" :loading="loading" class="dz-submit bgRed" @click="submit">提 交</el-button>
                        </div>

                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="">
                        <img src="../../assets/images/ad_6.png" alt="" class="w100">
                    </div>
                    <div class="mw-modular-box">
                        <img src="../../assets/images/ad_4.png" alt="" class="w100">
                    </div>
                    <div class="mw-modular-box">
                        <img src="../../assets/images/ad_5.png" alt="" class="w100">
                    </div>
                </el-col>
            </el-row>
        </article>
        <ConcatsControl></ConcatsControl>
    </div>
</template>
<script>
import ConcatsControl from '../../templates/concatsControl'
import $ from 'jquery'
import { baseUrl } from '../../assets/js/common'

export default {
    name: 'Customized',
    components: { ConcatsControl },
    data () {
        return {
            id: '',
            list_data: [],
            personalCheckOptions: [],

            checkAll: false,
            isIndeterminate: false,

            loading: false
        }
    },
    mounted () {
        // 初始化内容
        this.token_cyw = this.$cookies.get('token_cyw');
        if (this.token_cyw) {
            this.getUserInfoAll(this.token_cyw);
        } else {
            this.$router.push('/index')
        }
    },
    methods: {
        //页面操作
        // 获取全部品类信息
        getProductTreeList () {
            const self = this;
            self.$get(`${baseUrl.crm}/business/cyw/openapi/getProductTreeList.json`, {}).then(res => {
                if (res.code == 200) {
                    self.list_data = res.data;

                } else {
                    self.$message.error('信息获取失败')
                }
            })
        },

        getUserInfoAll (token_cyw) {
            const self = this;
            self.$get(`${baseUrl.sso}/user/userByToken/${token_cyw}`, {}).then(res_1 => {
                if (res_1.code == 200) {
                    self.id = res_1.data.id;
                    self.getProductTreeList();
                    self.getPersonalProduct();
                } else {
                    self.$confirm(res_1.msg, '提示', {
                        confirmButtonText: '确定',
                        showCancelButton: false,
                        type: 'error'
                    }).then(() => {
                        self.$router.push('/index')
                    })
                }
            }).catch(err_1 => {
                self.$confirm('未获取到此用户信息', '提示', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    type: 'error'
                }).then(() => {
                    self.$router.push('/index')
                })
            })
        },

        // 获取当前用户已定制的产品
        getPersonalProduct () {
            const self = this;
            self.$get(`${baseUrl.crm}/business/cyw/openapi/getSignTreeList.json/${self.id}`, {}).then(res => {
                if (res.code == 200) {
                    if (res.data.length == 0) {
                        self.$message({
                            message: '暂无定制信息',
                            type: 'warning'
                        })
                    } else {
                        $.each(res.data, (index, item) => {
                            $.each(item['childList'], (cIndex, cItem) => {
                                self.personalCheckOptions.push(cItem.productId);
                            })
                        })
                    }
                } else {
                    self.$message.error('信息获取失败')
                }
            })
        },

        handleCheckSingle (checks) {
            const newArr = checks.filter(Boolean);
            this.personalCheckOptions = newArr;
            this.checkAll = checks.length === this.list_data.length;
            this.isIndeterminate = checks.length > 0 && checks.length < this.list_data.length;
        },

        handleCheckAll (val) {
            const self = this;
            let checkIds = [];
            self.isIndeterminate = false;
            if (val) {
                $.each(self.list_data, (index, item) => {
                    if (item['childList']) {
                        $.each(item['childList'], (cIndex, cItem) => {
                            checkIds.push(cItem['productId'])
                        })
                    }
                })
            }
            self.personalCheckOptions = checkIds;
        },

        // 提交数据
        submit () {
            const self = this;
            // if (self.personalCheckOptions.length == 0) {
            //     self.$message({
            //         message: '请选择定制品种',
            //         type: 'warning'
            //     })
            // } else {
                self.loading = true;
                const priceCustom = self.personalCheckOptions.join(',');
                self.$post(`${baseUrl.crm}/business/cyw/openapi/updateCYWUser.json`, {crmUserId: self.id, priceCustom: priceCustom}).then(res => {
                    if (res.code == 200) {
                        self.$message('您已成功定制');
                    } else {
                        self.$message.error('定制失败，请重试');
                    }
                    self.loading = false;
                })
            // }
        }
    },
}
</script>

<style scoped>
    @import url('customized.css');
</style>